// Generated by Claude Code
import { BaseIdModel } from '#core/entities/shared/BaseModels.ts'

/**
 * How a vendor relates to a part. Mirrors the backend `PartVendorType` flag
 * enum, serialized on the wire as a non-empty array of these lowercase names.
 */
export type PartVendorType = 'supplier' | 'manufacturer' | 'service_provider'

/** All part↔vendor relation types, in display order. */
export const PART_VENDOR_TYPES: PartVendorType[] = ['supplier', 'manufacturer', 'service_provider']

/** Maps a {@link PartVendorType} to its `shared.fields.*` i18n key. */
export const PART_VENDOR_TYPE_LABEL_KEYS: Record<PartVendorType, string> = {
  supplier: 'shared.fields.supplier',
  manufacturer: 'shared.fields.manufacturer',
  service_provider: 'shared.fields.serviceProvider',
}

/**
 * A vendor linked to a part, carrying HOW it relates to that part. Mirrors the
 * backend `PartVendorSchema` (a `VendorMinimalSchema` plus a `type` bitmask
 * serialized as an array of names). `id` is the **vendor** id — the link row has
 * none, so links are addressed by vendor. One list, never split per type.
 */
export default class PartVendor extends BaseIdModel {
  name: string = ''
  /** Non-empty set of relation types (e.g. `['manufacturer', 'supplier']`). */
  type: PartVendorType[] = []
}
